export default "__VITE_ASSET__ebVwdnm1__"